module.exports = __webpack_public_path__ + "img/passport21.4bbcbf96.png";